<app-header></app-header>

<div class="flex mt-2">
    <app-sidebar optionMenu="7"></app-sidebar>

    <div class="flex flex-col w-full items-start gap-12">

        <div class="flex cursor-pointer relative left-16 top-8" [routerLink]="['/ia']">
            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">
                <path d="M8 15L1 8L8 1" stroke="#3C00A3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <p class="relative left-2 bottom-1">IA / Filtro automático</p>
        </div>


        <div class="w-[90%] mx-auto rounded-2xl bg-white p-6 font-sans text-[#4B4B59]">
            <!-- Descripción -->
            <p class="mb-8">
                Agrega palabras clave para filtrar el contenido de forma automática y actívalas o desactívalas cuando lo necesites.
            </p>

            <!-- Campo para agregar palabras -->
            <div id="keywordForm" class="mb-7 flex w-full gap-4">
                <div class="flex min-w-0 flex-1 items-center gap-4 bg-[#E5E5E5] px-8">
                <svg class="h-7 w-7 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true">
                    <circle cx="10.8" cy="10.8" r="7.3"/>
                    <path d="m16.2 16.2 5 5"/>
                </svg>
                <input
                    id="keywordInput"
                    [(ngModel)]="inputKeyword"
                    (keydown.enter)="saveKeywords()"
                    type="text"
                    placeholder="Escribe una palabra..."
                    aria-label="Nueva palabra clave"
                    class="h-[44px] w-full min-w-0 bg-transparent outline-none placeholder:text-[#696969] focus:ring-0"
                />
                </div>

                <button
                type="submit"
                [ngClass]="inputKeyword.length > 0 ? 'bg-[#4B16B5]': 'bg-[#D8C9F0]'"
                (click)="saveKeywords()"
                class="w-[92px] shrink-0 rounded-xl  text-white transition hover:bg-[#C6B0E8] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#4B16B5]"
                >
                Agregar
                </button>
            </div>

            <!-- Encabezado y ordenamiento -->
            <div class="mb-7 flex flex-wrap items-center justify-between gap-4">
                <div class="flex items-center gap-5">
                <h2 class="font-bold">Palabras</h2>
                <span id="activeCount" class="text-[#737383]" aria-live="polite">
                    {{activeCount}}
                </span>
                </div>

                <div class="flex flex-wrap items-center gap-5">
                <span class="text-[#737383]">Ordenar por</span>

                <div class="flex items-center rounded-full bg-[#F0EFF5] p-1.5" role="group" aria-label="Ordenar palabras">
                    <button
                    type="button"
                    data-sort="chronological"
                    aria-pressed="false"
                    class="sort-button flex items-center gap-3 rounded-full px-5 py-1 transition"
                    [ngClass]="sortMode == 'chronological' ? 'bg-white text-[#4020AC] shadow-md': 'bg-[#F0EFF5] text-[#60606D]'"
                    (click)="changeSortMode('chronological')"
                    >
                    <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true">
                        <circle cx="12" cy="12" r="9.5"/>
                        <path d="M12 6v6l4 2"/>
                    </svg>
                    Cronológico
                    </button>

                    <button
                    type="button"
                    data-sort="alphabetical"
                    aria-pressed="true"
                    class="sort-button flex items-center gap-3 rounded-full  px-5 py-1 transition"
                    [ngClass]="sortMode == 'alphabetical' ? 'bg-white text-[#4020AC] shadow-md': 'bg-[#F0EFF5] text-[#60606D]'"
                    (click)="changeSortMode('alphabetical')"
                    >
                    <span class="text-base font-extrabold">A<span class="text-xs">Z</span></span>
                    Alfabético
                    </button>
                </div>
                </div>
            </div>

            <!-- Lista de palabras -->
            <div id="keywordList" class="grid grid-cols-1 gap-6 sm:grid-cols-2 xl:grid-cols-3" aria-label="Lista de palabras clave">
                <div *ngFor="let keyword of keywords" 
                    class="flex min-w-0 items-center gap-5 rounded-xl border px-3 py-3 transition-colors" 
                    [ngClass]="keyword.active ? 'border-[#D9C8FF] bg-[#F2ECFC]': 'border-[#E5E5EB] bg-[#F7F7F9]'"
                >
                    <span class="min-w-0 flex-1 break-words text-sm" [ngClass]="keyword.active ? 'text-[#24212B]': 'text-[#92929D]'">
                        {{ keyword.text }}
                    </span>
                    <button
                        type="button"
                        class="relative h-7 w-12 shrink-0 rounded-full transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#4B16B5]"
                        [ngClass]="keyword.active ? 'bg-[#4B20B5]': 'bg-[#C8C8D0]'"
                        (click)="toggleKeyword(keyword)"
                        aria-label="Activar o desactivar palabra clave">
                        <span 
                            class="absolute top-1.5 h-4 w-4 rounded-full bg-white shadow-sm transition-all "
                            [ngClass]="keyword.active ? 'left-[26px]': 'left-1.5'"
                        ></span>
                    </button>

                    <button
                        class="shrink-0 rounded-lg p-1 text-[#646471] transition hover:bg-[#E5DDF4] hover:text-[#4B20B5] focus-visible:outline-2 focus-visible:outline-[#4B16B5]"
                        [attr.aria-label]="'Eliminar ' + keyword.text"
                        (click)="confirmarEliminacion(keyword)"
                    >
                        <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="1.8"
                            stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                            <path d="M3 6h18"/>
                            <path d="M8 6V4h8v2"/>
                            <path d="m19 6-1 14H6L5 6"/>
                            <path d="M10 10v6M14 10v6"/>
                        </svg>
                    </button>
                </div>
            </div>
        </div>


        
        <div *ngIf="mostrarModal && keywordToDelete" class="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4"
            (click)="cancelarEliminacion()" >
            <div
                class="bg-white w-full max-w-xl rounded-3xl p-6 md:p-8 shadow-xl"
                role="dialog"
                aria-modal="true"
                aria-labelledby="delete-modal-title"
                (click)="$event.stopPropagation()"
            >
                <!-- Icono -->
                <div class="w-20 h-20 rounded-3xl bg-pink-100 flex items-center justify-center mb-8">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="w-11 h-11 text-pink-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        stroke-width="2"
                    >
                        <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M9 7V4a1 1 0 011-1h4a1 1 0 011 1v3M4 7h16"
                        />
                    </svg>
                </div>

                <!-- Mensaje -->
                <h2 id="delete-modal-title" class="text-sm  md:text-md font-bold text-gray-900 mb-4" >
                    ¿Eliminar esta palabra?
                </h2>

                <p class="text-xl md:text-sm text-gray-600 leading-relaxed mb-10">
                    Se eliminará
                    <strong class="font-bold text-gray-700">
                        “{{ keywordToDelete.text }}”
                    </strong>
                    del filtro automático y dejará de aplicarse al contenido.
                    Esta acción no se puede deshacer.
                </p>

                <!-- Acciones -->
                <div class="flex flex-col-reverse sm:flex-row justify-end gap-4">
                    <button
                        type="button"
                        (click)="cancelarEliminacion()"
                        class="px-4 py-3 rounded-2xl border-2 border-gray-300 text-gray-700 font-bold text-sm hover:bg-gray-50 transition"
                    >
                        Cancelar
                    </button>

                    <button
                        type="button"
                        (click)="eliminarKeyword()"
                        class="px-4 py-3 rounded-2xl bg-pink-600 text-white font-bold text-sm hover:bg-pink-700 transition"
                    >
                        Sí, eliminar
                    </button>
                </div>
            </div>
        </div>



    </div>
</div>